export const cn = (...x: Array<string | false | null | undefined>) => x.filter(Boolean).join(' ');

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Build a Date from any of the inputs the citizen screens pass around.
 *
 * A bare `YYYY-MM-DD` string (the shape of `ELECTION.general`, bill dates and
 * API date columns) is parsed as a LOCAL calendar day. `new Date('2026-11-03')`
 * is UTC midnight, which formats as Mon, Nov 2 anywhere west of Greenwich (#936).
 * Anything carrying a time component, a number or a Date is left to the native
 * constructor.
 */
export function toLocalDate(d: string | number | Date): Date {
  if (typeof d === 'string' && DATE_ONLY.test(d)) {
    const [y, m, day] = d.split('-').map(Number);
    return new Date(y, m - 1, day);
  }
  return new Date(d);
}

export function fmtDateShort(d: string | number | Date): string {
  return toLocalDate(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function fmtDateMed(d: string | number | Date): string {
  return toLocalDate(d).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
}

export function daysUntil(d: string | number | Date): number {
  return Math.max(0, Math.ceil((toLocalDate(d).getTime() - Date.now()) / 86400000));
}

export function partyColor(p?: string | null): string {
  if (!p) return '#6B7280';
  const k = p.toLowerCase();
  if (k.includes('democrat')) return '#3B6BD9';
  if (k.includes('republican')) return '#D33C3C';
  if (k.includes('independ')) return '#1F9A55';
  if (k.includes('green')) return '#3F7C44';
  if (k.includes('libertarian')) return '#C9742B';
  return '#6B7280';
}

export function initialsOf(name?: string | null): string {
  if (!name) return '?';
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]!.toUpperCase())
    .join('');
}
